const Wall = ({position, size, zIndex = 0, image, testColor}) => {
    return (
        <div
            style={{
                position: 'absolute',
                left: position.x,
                top: position.y,
                width: size.width,
                height: size.height,
                zIndex: zIndex
            }}
        >
            {image ? <img src={image} style={{height: size.height,  imageRendering: 'pixelated'}}/> : ''}
            {testColor}
            </div>
    );
}

export default Wall